















import TDSButton from "@/components/common/TDSButton.vue";
import {Component, Vue} from "vue-property-decorator";

@Component({
    components: {
        TDSButton
    }
})

export default class PricingBanner extends Vue {
    public isModalOpened: boolean = false;
    public isLoading: boolean = false;

    get discountRate() {
        return this.$store.state.discountRate;
    }

    get userEmail(){
        return this.$store.state.account.email;
    }

    get userName(){
        return this.$store.state.account.firstName;
    }

    async downloadPriceList() {
        try {
            this.isLoading = true;
            await this.$store.dispatch("DOWNLOAD_PACKAGES_INFO_CSV");
        } catch (e) {
            console.error("Failed to download CSV", e);
        } finally {
            this.isLoading = false;
        }
    }
}
